import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import {notification, Typography} from "antd";
import {uuidv4} from "../../../../../utils";
import {getDeviseSymbol} from "../../../../../i18n";

const {Text,Title}=Typography

export default function ScreenDonSection({context,campagneData,})
{
    const [loading,setLoading]=useState(true)
    const [dons,setDons]=useState([])

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0,style:"currency",currency:"EUR" })
    const formater2=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0})

    const partnerMontant=campagneData?.partnerMontant || 1

    let donorName=campagneData.config?.donorName || "Parrainages"

    const screenOptions=campagneData?.screenOptions || {}


    const getDisplayName=(campagneExtraData={})=>{
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons=async ()=>{
        let url="/campagne/donors/"+campagneData.id

        const res=await ApiService.get(url)
        let _dons=res.data

        if(screenOptions.minMontant){
            _dons=_dons.filter(i=>i.montant>=screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    return (
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",padding:"0 1vw"}}>
            <div style={{overflow:"visible",width:"87%",transform:"scale(0.9)",height:"15vh",display:"flex",alignItems:"center",flexDirection:"row-reverse",gap:"2vw"}}>
                {dons.map((d,index)=>{

                    //console.log(index)

                    let className="screen-don-card"
                    let className2=""

                    if(index<4){
                        className2+=" screenDonFadeIn"
                    }else{
                        className2+=" screenDonFadeOut"
                    }

                    //console.log(className)

                    const nb=formater2.format(d.montant/partnerMontant)
                    const text=nb>1?"Parrainages":"Parrainage"

                    return(
                        <div style={{position:"relative"}} className={className2} key={d.id}>
                            <div style={{
                                flexDirection: "column",
                                border: "0px solid red",
                                overflow: "hidden",
                                backgroundColor: "#869723",
                                display:"flex",
                                justifyContent:"center",
                                alignItems:"center",
                                gap:5,
                                paddingBottom:5
                            }} className={className}>

                                <div style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <span style={{
                                        color: "#FFF",
                                        fontSize: "3vh",
                                        textAlign: "center",
                                        fontFamily: "BioRhyme !important"
                                    }}>{getDisplayName(d.campagneExtraData)}</span>
                                </div>

                                <div style={{
                                    padding:"0.5vw 1vw",
                                    borderRadius:15,
                                    backgroundColor: "rgba(255,255,255,0.2)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <span style={{
                                        color: "#FFF",
                                        fontSize: "3vh",
                                        textAlign: "center",
                                        fontFamily: "BioRhyme !important",
                                        fontWeight:"800"
                                    }}>
                                        {nb} {text}
                                    </span>
                                </div>
                            </div>
                        </div>

                    )
                })}
            </div>
        </div>
    )
}
